import type { SearchIssuesCriteria } from '@hetivo/hetivo-lib-types';

import type { SearchIssuesParams } from './issue.api';

/**
 * Query-key factory for the Issues feature (SWOOP-255). `stats` is keyed on the criteria object, so the
 * sidebar badge (scope-only criteria) and the page's Open KPI (same scope, no search/type) hash to the
 * same key and share one fetch — which is what keeps the badge and the KPI in agreement (SC-004).
 */
export const issueKeys = {
  all: ['issues'] as const,
  detail: (id: string): readonly unknown[] => [...issueKeys.all, 'detail', id] as const,
  search: (params: SearchIssuesParams): readonly unknown[] => [...issueKeys.all, 'search', params] as const,
  stats: (criteria: SearchIssuesCriteria): readonly unknown[] => [...issueKeys.all, 'stats', criteria] as const,
};
